import Select from 'react-select'
import { useTranslation } from 'react-i18next'
import { CurrencyOption } from './DepositInfo.styled'

const customStyles = {
  control: (provided) => ({
    ...provided,
    color: 'white',
    backgroundColor: 'unset',
    border: '1px solid #fff',
    borderRadius: '20px',
  }),
  option: (provided) => ({
    ...provided,
    padding: '10px 10px',
    backgroundColor: '#212226',
    color: '#fff',
  }),
  menu: (provided) => ({
    ...provided,
    backgroundColor: '#212226',
    marginBottom: '8px',
  }),
}

export const NetworkSelect = ({ selectedExternalCoin, coin, onSelect }) => {
  const { t } = useTranslation()

  return (
    <Select
      maxMenuHeight={150}
      menuPlacement="top"
      key={JSON.stringify(selectedExternalCoin)}
      value={coin?.tokens.find((x) => x.tokenId === selectedExternalCoin?.token)}
      options={coin?.tokens
        .filter((x) => x.crypto !== 'ETH' || x.chain !== 'BASE')
        .sort((a, b) =>
          a.name === 'Ethereum' ? -1 : b.name === 'Ethereum' ? 1 : (a.name || '').localeCompare(b.name || '')
        )}
      placeholder={t('wallet.selectNetwork', 'Select network')}
      onChange={(e) => onSelect(e!.tokenId, e!.chain)}
      isSearchable={false}
      styles={customStyles}
      formatOptionLabel={(e) => (
        <CurrencyOption>
          <img alt={e.name} src={e.chainLogo} />
          <span>{e.name === 'Ethereum' && e.network === 'NATIVE' ? 'Ethereum ERC20' : `${e.name}(${e.network})`}</span>
        </CurrencyOption>
      )}
    />
  )
}
